import {InjectionToken} from '@angular/core';


// Config token
export const AUTH_MODULE_OPTIONS_TOKEN = new InjectionToken<AuthModuleOptions>('forRoot() auth configuration.');

// Module options
export interface AuthModuleOptions {
  clientLoginUrl: string;
  apiRecoveryUrl: string;
  apiRecoveryChangePasswordUrl: string;
  apiLoginUrl: string;
  apiRefreshUrl: string;
  apiMeUrl: string;
}
